// @flow
export { default } from './CategoryItem';



// WEBPACK FOOTER //
// ./src/components/categories/CategoryItem/index.js